import axios from "axios";

const api = axios.create({
    baseURL: process.env.REACT_APP_BASE_API,
});

api.interceptors.request.use(function (config) {
    const token = localStorage.getItem("rdnatoken");

    if (token) {
        config.headers = Object.assign({}, config.headers ?? {}, { Authorization: `Bearer ${token}` });
    }

    return config;
});

export default api;
